/*
 * Module for attribute info
 */

define([
  "marionette",
  "backbone",
  "underscore",
  "messaging/messenger",
  "./attributeInfoView",
], function (Marionette, Backbone, _, Messenger, AttributeInfoView) {
  var AttributesController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "attributeInfo";
      this.namespace = options.namespace;
      this.region = options.region;
      this.responseId = options.responseId;
      this._setUpVents();
      this.insertType = "text";
    },

    show: function (attributeId) {
      this.attributeId = attributeId;
      try {
        this.topicAttributes = Messenger.reqres.request("fetch:conversation:response:attributes");
      } catch (e) {
        this.topicAttributes = new Backbone.Collection();
      }
      this.topicAttributes.onSynced(function () {
        var topicAttribute = this.topicAttributes.find(function (attr) {
          // noinspection EqualityComparisonWithCoercionJS
          return attr.get("attributeId") == attributeId;
        });

        if (_.isUndefined(topicAttribute)) {
          topicAttribute = new Backbone.Model();
        }
        topicAttribute.set("insertType", this.insertType);
        this.layout = new AttributeInfoView.attributeInfoLayout({ model: topicAttribute });
        this.showRegion(this.layout);
      }, this);
    },

    _setUpVents: function () {
      Messenger.vent.on(
        Messenger.getFullName("show:attributeInfo", this.namespace),
        function (attribute) {
          this.show(attribute.get("id"));
        },
        this,
      );

      Messenger.vent.on(
        Messenger.getFullName("attribute:insert:type:selected", this.namespace),
        function (insertType) {
          this.insertType = insertType;
          this.show(this.attributeId);
        },
        this,
      );
    },
  });

  return AttributesController;
});
